<template>
  <b-container fluid id="app" class="ui container">
    <h2 class="mt-5">Student List</h2>
    <b-row>
      <b-col md="5">
        <FormulateInput
          class="text-left"
          type="date"
          name="date"
          label="Date"
          help="Sample date help text sample sample sample"
          v-model="date"
          @input="updateStudents()"
        />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="6" class="my-1">
        <b-input-group size="sm">
          <b-form-input
            id="filter-input"
            v-model="filter"
            type="search"
            placeholder="Type to Search"
          ></b-form-input>

          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-button
          @click="$router.push({ name: 'RequestForm' })"
          class="mr-1 mb-1"
        >
          Add New Record
        </b-button>
      </b-col>

      <b-col md="12" class="my-1 text-left">
        <b-form-checkbox-group v-model="filterOn" class="mt-1">
          <b-form-checkbox
            v-for="field in fields.slice(0, -1)"
            :key="field.key"
            :value="field.key"
          >
            {{ field.label }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-col>

      <b-col class="text-left mt-3">
        <h6>Displayed Columns</h6>
      </b-col>
      <b-col md="12" class="my-1 text-left">
        <b-checkbox
          :disabled="visibleFields.length == 1 && field.visible"
          v-for="field in fields.slice(0, -6)"
          :key="field.key"
          v-model="field.visible"
          @change="checkWeekdaysSelectAll"
          inline
        >
          {{ field.label }}
        </b-checkbox>
        <b-form-checkbox
          v-model="allWeekdaysSelected"
          @change="toggleAllWeekdays"
          inline
        >
          Weekly Schedule
          <!-- {{ allWeekdaysSelected ? 'Un-select All Weekdays' : 'Select All Weekdays' }} -->
        </b-form-checkbox>
        <br /><br />
      </b-col>
    </b-row>
    <!-- Main table element -->
    <b-table
      striped
      hover
      outlined
      responsive
      id="main-table"
      ref="table"
      :items="studentList"
      :fields="visibleFields"
      :filter="filter"
      :filter-included-fields="filterOn"
      stacked="md"
      show-empty
      primary-key="id"
      :tbody-transition-props="transProps"
    >
      <template #cell(actions)="row">
        <b-button size="sm" @click="updateStudentDetail(row)" class="mr-1 mb-1">
          {{ row.detailsShowing ? 'Hide' : 'Details' }}
        </b-button>
        <b-button size="sm" @click="onEdit(row)" class="mr-1 mb-1">
          Change Request
        </b-button>
        <b-button
          v-if="user.role === 'operations'"
          size="sm"
          @click="onNoRide(row)"
          class="mr-1 mb-1"
        >
          No Ride
        </b-button>
        <b-button
          size="sm"
          @click="onCancel(row.item, row.index, $event.target)"
          variant="danger"
          class="mr-1 mb-1"
        >
          Cancel
        </b-button>
      </template>

      <template #row-details="row">
        <b-card>
          <pre>
            {{ detailList[row.item.internalId] }}
          </pre>
        </b-card>
      </template>
    </b-table>
    <!-- Info modal -->
    <b-modal
      :id="cancelModal.id"
      :title="cancelModal.title"
      hide-footer
      @hide="resetCancelModal"
    >
      <cancel-form id="cancelForm" :studentInfo="cancelModal.content" />
    </b-modal>
  </b-container>
</template>

<script>
import FieldsDef from './StudentList/FieldsDef.js'
import DropdownLists from '../components/DropdownLists.json'
import CancelForm from './CancelForm.vue'
import { getStudentData, getStudentDetail, getUser } from '../services/api.js'

export default {
  components: { CancelForm },
  name: 'studentList',
  data() {
    return {
      user: {},
      studentList: [],
      detailList: {},
      fields: FieldsDef,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      cancelConfirmed: false,
      allWeekdaysSelected: false,
      weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      gradeList: DropdownLists.gradeList,
      directionList: DropdownLists.directionList,
      showCancel: false,
      cancelModal: {
        id: 'cancel-modal',
        title: '',
        content: ''
      },
      date: this.today()
    }
  },
  methods: {
    toggleAllWeekdays(checked) {
      for (const field of this.fields)
        if (this.weekDays.includes(field.label)) {
          field.visible = checked ? true : false
        }
    },
    checkWeekdaysSelectAll() {
      let selectedWeekdays = []
      for (const field of this.visibleFields)
        if (this.weekDays.includes(field.label)) {
          selectedWeekdays.push(field.label)
        }
      if (selectedWeekdays) {
        let b = selectedWeekdays.slice(0, 5)
        let a = this.weekDays.slice(0, 5)
        if (a.every((val, index) => val === b[index])) {
          this.allWeekdaysSelected = true
        } else {
          this.allWeekdaysSelected = false
        }
      }
    },
    onCancel(item, index, button) {
      this.cancelModal.title = `Transportation Cancellation Form for ${item.firstName}`
      this.cancelModal.content = item
      this.$root.$emit('bv::show::modal', this.cancelModal.id, button)
    },
    resetCancelModal() {
      this.cancelModal.title = ''
      this.cancelModal.content = ''
    },
    async onEdit(row) {
      let internalId = row.item.internalId
      let detail = {}
      if (this.detailList[internalId]) {
        detail = this.detailList[internalId]
      } else {
        let studentResponse = await getStudentDetail(internalId)
        if (studentResponse.statusText != 'OK') {
          alert('Network Problem')
          throw new Error(studentResponse.statusText)
        }
        detail = studentResponse.data
      }
      this.$router.push({
        name: 'RequestForm',
        params: { defaultValues: detail }
      })
    },
    async onNoRide(row) {
      const { internalId, studentId, firstName, lastName } = row.item
      this.$router.push({
        name: 'OneTimeNoRide',
        params: {
          student: {
            internalId: internalId,
            studentId: studentId,
            firstName: firstName,
            lastName: lastName
          }
        }
      })
    },
    async updateStudents() {
      let userResponse = await getUser()
      if (userResponse.status !== 200) {
        alert('Network Problem')
        throw new Error(userResponse.statusText)
      }
      this.user = userResponse.data

      let studentResponse = await getStudentData(this.date)
      if (studentResponse.statusText != 'OK') {
        alert('Network Problem')
        throw new Error(studentResponse.statusText)
      }
      studentResponse = studentResponse.data
      this.studentList = studentResponse
      for (const [key, value] of Object.entries(this.studentList)) {
        for (const day of this.weekDays) {
          let directionKey = value.schedule[day.toLowerCase().slice(0, 3)]
          this.studentList[key][day] = this.directionList[directionKey]
        }
      }
    },
    async updateStudentDetail(row) {
      let internalId = row.item.internalId
      // already open
      if (row.detailsShowing) {
        delete this.detailList[internalId]
      } else {
        let studentResponse = await getStudentDetail(internalId)
        if (studentResponse.statusText != 'OK') {
          alert('Network Problem')
          throw new Error(studentResponse.statusText)
        }
        this.detailList[internalId] = studentResponse.data
      }
      row.toggleDetails()
    },
    today() {
      var today = new Date()
      var month = today.getMonth() + Number(1)
      if (month < 10) {
        month = '0' + month
      }
      var date = today.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return today.getFullYear() + '-' + month + '-' + date
    }
  },
  mounted() {
    this.updateStudents()
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible)
    }
  }
}
</script>

<style>
#studentList {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
}
table#main-table .flip-list-move {
  transition: transform 0.5s;
}
</style>
